module.exports = __webpack_public_path__ + "img/ic_online.2b33fadc.svg";